// extracted by mini-css-extract-plugin
export default {"fadeIn":"index_fadeIn","fadeOut":"index_fadeOut"};